import styled from 'styled-components'

interface StyledLogoContainerProps {
  $backgroundColor?: string
  $position?: string
  $width?: string
  $useTransparent?: boolean
  $logoPosition?: string
}

export const StyledLogoContainer = styled.div<StyledLogoContainerProps>`
  position: absolute;
  top: ${({ $logoPosition }) => {
    if ($logoPosition === 'logoCenteredFullHeight') {
      return '0px'
    } else {
      return '50px'
    }
  }};
  left: 50%;
  transform: translateX(-50%);

  width: ${({ $logoPosition }) => {
    if ($logoPosition === 'logoOnly') {
      return '70%'
    } else if ($logoPosition === 'logoCenteredFullWidth') {
      return '100%'
    } else {
      return '60%'
    }
  }};

  height: ${({ $logoPosition }) => {
    if ($logoPosition === 'logoCenteredHalfHeight') {
      return '35%'
    } else if ($logoPosition === 'logoCenteredFullHeight') {
      return '45%'
    }
  }};

  max-width: ${({ $logoPosition }) => {
    if ($logoPosition === 'logoOnly') {
      return '100%'
    } else if ($logoPosition === 'logoCenteredFullWidth') {
      return '100%'
    } else {
      return '60%'
    }
  }};
  max-height: ${({ $logoPosition }) => {
    if ($logoPosition === 'logoOnly') {
      return '100%'
    } else if ($logoPosition === 'logoCenteredFullWidth') {
      return '60%'
    } else if ($logoPosition === 'logoCenteredHalfHeight') {
      return '70%'
    } else if ($logoPosition === 'logoCenteredFullHeight') {
      return '100%'
    }
  }};
  background-color: ${({ $backgroundColor, $useTransparent, $logoPosition }) => {
    if ($logoPosition !== 'logoOnly') {
      if ($useTransparent) {
        return $backgroundColor + '80'
      } else {
        return $backgroundColor
      }
    } else {
      return 'unset'
    }
  }};
  box-shadow: ${({ $backgroundColor, $logoPosition }) =>
    $backgroundColor && $logoPosition !== 'logoOnly' ? '0 10px 10px -5px rgba(0, 0, 0, 0.5)' : 'unset'};
  display: flex;
  justify-content: center;
  align-items: ${({ $logoPosition }) => {
    if ($logoPosition === 'logoCenteredFullHeight') {
      return 'flex-end';
    } else {
      return 'center';
    }
  }};
  padding-bottom: ${({ $logoPosition }) => {
    if ($logoPosition === 'logoCenteredFullHeight') {
      return '10%';
    }
    else {
      return 'unset';
    }
  }};
  box-sizing: border-box;
  min-height: 100px;
  z-index: 10;
`

interface StyledLogoImgProps {
  $backgroundColor?: string;
  $logoPosition?: string;
}

export const StyledLogoImage = styled.img<StyledLogoImgProps>`
  width: 100%;
  height: auto;
  display: block;
  object-fit: contain;
  max-width: ${({ $logoPosition }) => {
    if ($logoPosition === 'logoOnly') {
      return '100%'
    } else if ($logoPosition === 'logoCenteredFullWidth') {
      return '70%'
    } else {
      return '60%'
    }
  }};
  max-height: ${({ $logoPosition }) => {
    if ($logoPosition === 'logoOnly') {
      return '100%'
    } else if ($logoPosition === 'logoCenteredFullWidth') {
      return '70%'
    } else if ($logoPosition === 'logoCenteredHalfHeight') {
      return '60%'
    } else if ($logoPosition === 'logoCenteredFullHeight') {
      return '100%'
    }
  }};
  box-shadow: ${({ $backgroundColor, $logoPosition }) =>
    $logoPosition === 'logoOnly' ? '0 10px 10px -5px rgba(0, 0, 0, 0.5)' : 'unset'};
`
